export default "__VITE_ASSET__DQXC3x57__"